import { Link } from "react-router-dom";
import { formatDate } from "../../../Utils/externalFunctions";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import DeleteModal from "../../../Layout/Components/DeleteModal";
import CutiModal from "../components/CutiModal";
// import deleteCuti from "../services/deleteCuti";
import { Trash2 } from "react-feather";
import { Button } from "reactstrap";
import { PERMISSIONS } from "../../../Constant/FeatureSelection";
import RoleContext from "../../../Context/RoleContext";
import { useContext } from "react";
import { useCuti } from "../../../Context/CutiContext";

const CutiColumns = (resetState, data) => {
  const cutiAPI = useCuti();  
  const { checkPermission } = useContext(RoleContext);
  const hasPermission =
    checkPermission(PERMISSIONS.DELETE_CUTI) ||
    checkPermission(PERMISSIONS.ADD_CUTI) ||
    checkPermission(PERMISSIONS.CHANGE_CUTI);

  const columns = [
    {
      name: <DataTableTitle text={"Grup"} />,
      selector: (row) =>
        data.groupStaf?.find(
          (groupStaf) =>
            groupStaf.id_group ===
            data.staf?.find((staf) => staf.id === row.id_user)?.group_staf
        )?.nama,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Nama Staf"} />,
      selector: (row) =>
        data.staf?.find((staf) => staf.id === row.id_user)?.nama ?? "Memuat",
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Tipe Cuti"} />,
      selector: (row) => row.id_tipe_absensi,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Tanggal"} />,
      selector: (row) =>
        `${formatDate(row.tanggal_mulai_cuti)} - ${formatDate(
          row.tanggal_selesai_cuti
        )}`,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Keterangan"} />,
      selector: (row) => row.keterangan,
      sortable: true,
      wrap: true,
    },
  ];

  if (hasPermission) {
    columns.push({
      name: <DataTableTitle text={"Operasi"} />,
      width: "15%",
      cell: (row) => (
        <div>
          {checkPermission(PERMISSIONS.ADD_CUTI) && (
            <CutiModal create={false} data={row} resetState={resetState} />
          )}
          {checkPermission(PERMISSIONS.DELETE_CUTI) && (
            <DeleteModal
              name={"cuti"}
              axiosDelete={cutiAPI.deleteCuti}
              pk={row.id_cuti}
              resetState={resetState}
              CustomButton={({ toggle }) => {
                return (
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      toggle();
                    }}
                  >
                    <Button
                      className={
                        "btn-danger w-100 d-flex justify-content-start align-items-center"
                      }
                    >
                      <Trash2 size={12} />
                      Hapus
                    </Button>
                  </Link>
                );
              }}
            />
          )}
        </div>
      ),
    });
  }

  return columns;
};

export default CutiColumns;